/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isBrowser, isMobile } from 'react-device-detect';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../Modal';

const CalendarLayout = ({
  children,
  renderFooter = null,
  renderHeader = null,
  renderHeaderMobile = null,
  onClose,
}) => {
  const scrollHostRef = useRef();

  useEffect(() => {
    const element = document.getElementsByClassName('scrollable-content')[0];
    element.scrollTop = element.scrollHeight;
  }, []);

  return (
    <ModalRoot>
      <Modal dialogClassName="mh-75">
        {isBrowser && (
          <ModalHeader>
            <i
              onClick={onClose}
              onKeyDown={onClose}
              role="button"
              className="close-btn cursor-pointer icon icon-close-other text-shadow"
              tabIndex={-1}
              aria-label="Close"
            />
          </ModalHeader>
        )}
        <ModalBody>
          <>
            {isBrowser && <div className="pe-5">{renderHeader()}</div>}
            {isMobile && <div className="pe-2">{renderHeaderMobile()}</div>}
            <div
              className={isMobile ? 'd-flex' : ''}
              style={isMobile ? { flex: '1', height: '80%' } : {}}>
              <div
                className={`scrollable-content ${isBrowser ? 'pe-5' : 'pe-2'}`}
                style={
                  isMobile
                    ? {
                        height: renderFooter ? 'auto' : '100%',
                        display: 'flex',
                        flex: '1',
                        overFlow: 'hidden',
                        justifyContent: 'center',
                      }
                    : { height: renderFooter ? 'auto' : '100%' }
                }
                ref={scrollHostRef}>
                {children}
              </div>
            </div>
            {renderFooter ? (
              <div className={`modal-footer border-0  pt-4 ${isBrowser ? 'pe-5' : 'pe-2'}`}>
                <div className="row d-flex justify-content-center w-100">{renderFooter()}</div>
              </div>
            ) : null}
          </>
        </ModalBody>
      </Modal>
    </ModalRoot>
  );
};

export default CalendarLayout;

CalendarLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  renderFooter: PropTypes.func,
  renderHeader: PropTypes.func,
  renderHeaderMobile: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};
